module.exports = __webpack_public_path__ + "img/angle-right.1158e633.svg";